import importer from 'common/importer'
const { navigateCustom } = importer('NavigationService', null)
export default function * success ({ res }) {
  if (window.sessionStorage.getItem('appointmentStartTime')) {
    window.sessionStorage.removeItem('appointmentStartTime')
  }
  window.sessionStorage.setItem('logOutFlow', true)
  yield navigateCustom(res)
}
